var config = {
  siteTitle: 'Improxy Heartbeat',
  siteDescription: 'Improxy Heartbeat',
  siteCannonicalUrl:
    process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
      ? 'http://localhost:3001 '
      : 'https://heartbeat.improxy.com',
  siteKeywords: '',
  cryptoKey: 'Improxy Heartbeat',
};

module.exports = config;
